var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 39,
    viewBox: "0 0 112 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_25)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddddd_1_25)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0477 21.9501H14.5347C14.7283 21.9501 14.8837 22.1457 14.806 22.3394L11.0818 31.7296C10.9648 32.0009 11.3531 32.2349 11.5468 32.0009L17.4841 25.4826C18.4545 24.1622 19.1526 21.9501 16.0477 21.9501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2171 6.00046C34.2405 6.00032 34.2638 6.00025 34.2871 6.00025H31.26C31.2588 6.00032 31.2576 6.00039 31.2565 6.00046H9.76085C9.62878 6.00046 9.48622 6.02329 9.33986 6.0652L9.33598 6.06744C8.97166 6.17258 8.58419 6.39565 8.27654 6.67891L8.27328 6.68079C8.12533 6.81748 7.99599 6.96809 7.89679 7.12617L4.21092 12.7538C4.06873 12.9815 3.99953 13.1937 3.99958 13.3712C3.99917 13.6777 4.20516 13.8806 4.59828 13.8806H4.94829V13.8796L4.94849 13.8795H4.94869L4.94864 13.8795H13.7578L13.7578 13.8795H13.9508L9.4889 21.5233C9.48609 21.5303 9.48354 21.5374 9.48123 21.5445C9.4189 21.7339 9.53481 21.9512 9.75987 21.9512H16.0462C19.151 21.9512 18.453 24.1633 17.4826 25.4837L21.7121 20.7881C21.8675 20.6318 21.7505 20.3221 21.5185 20.3221H18.3753C18.1423 20.3211 18.0263 20.0498 18.1826 19.8945L22.9165 13.8795H29.1251C29.7465 13.8795 30.5999 13.3741 30.9873 12.7538L34.6741 7.12617C35.0615 6.5058 34.9071 6.00046 34.2867 6.00046H34.2171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5341 22.9602C17.4443 22.6112 18.4923 23.3476 17.4836 25.483C18.4157 24.2413 19.0744 22.1462 16.3962 21.9505C16.2802 21.9505 16.1632 21.9505 16.0472 21.9505H14.5341C14.7278 21.9505 14.8832 22.1462 14.8055 22.3398L14.5341 22.9602Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 36.3859,
    height: 35.5966,
    rx: 4.75,
    stroke: "white",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2779 29.5483V9.90031H47.1739V6.22031H65.7339V9.90031H58.5019V29.5483H54.2779ZM68.1236 29.5483V12.5243H72.1236V29.5483H68.1236ZM68.1236 10.1243V6.22031H72.1236V10.1243H68.1236ZM88.0841 34.8923V26.3803H87.8601C87.4548 27.4256 86.7614 28.2683 85.7801 28.9083C84.7988 29.527 83.6148 29.8363 82.2281 29.8363C81.2041 29.8363 80.2654 29.655 79.4121 29.2923C78.5801 28.9083 77.8548 28.343 77.2361 27.5963C76.6388 26.8496 76.1801 25.9323 75.8601 24.8443C75.5401 23.735 75.3801 22.4656 75.3801 21.0363C75.3801 19.095 75.6574 17.4736 76.2121 16.1723C76.7881 14.8496 77.5881 13.8576 78.6121 13.1963C79.6574 12.535 80.8628 12.2043 82.2281 12.2043C83.1668 12.2043 83.9988 12.3536 84.7241 12.6523C85.4708 12.9296 86.1108 13.3243 86.6441 13.8363C87.1774 14.3483 87.5828 14.9563 87.8601 15.6603H88.0841L88.2441 12.5243H92.0841V34.8923H88.0841ZM83.7321 26.5723C84.6921 26.5723 85.4814 26.3483 86.1001 25.9003C86.7401 25.4523 87.2201 24.8763 87.5401 24.1723C87.8601 23.447 88.0201 22.6896 88.0201 21.9003V20.1403C88.0201 19.3296 87.8601 18.5723 87.5401 17.8683C87.2201 17.143 86.7401 16.567 86.1001 16.1403C85.4814 15.6923 84.6921 15.4683 83.7321 15.4683C82.8788 15.4683 82.1321 15.671 81.4921 16.0763C80.8521 16.4816 80.3508 17.1003 79.9881 17.9323C79.6254 18.743 79.4441 19.7776 79.4441 21.0363C79.4441 22.2523 79.6254 23.2763 79.9881 24.1083C80.3508 24.9403 80.8521 25.559 81.4921 25.9643C82.1321 26.3696 82.8788 26.5723 83.7321 26.5723ZM102.998 29.8683C100.587 29.8683 98.7203 29.3456 97.3976 28.3003C96.0963 27.255 95.4563 25.8896 95.4776 24.2043H99.4136C99.4349 25.2283 99.7869 25.975 100.47 26.4443C101.152 26.8923 102.027 27.1163 103.094 27.1163C104.182 27.1163 105.003 26.9243 105.558 26.5403C106.134 26.135 106.422 25.6016 106.422 24.9403C106.422 24.3643 106.283 23.927 106.006 23.6283C105.728 23.3083 105.312 23.0736 104.758 22.9243C104.203 22.7536 103.488 22.615 102.614 22.5083C101.654 22.359 100.768 22.1883 99.9576 21.9963C99.1469 21.783 98.4429 21.495 97.8456 21.1323C97.2483 20.7696 96.7789 20.2896 96.4376 19.6923C96.0963 19.095 95.9256 18.3483 95.9256 17.4523C95.9256 16.3003 96.2243 15.3403 96.8216 14.5723C97.4403 13.783 98.2829 13.1963 99.3496 12.8123C100.416 12.407 101.664 12.2043 103.094 12.2043C104.523 12.2043 105.76 12.4176 106.806 12.8443C107.851 13.271 108.651 13.879 109.206 14.6683C109.782 15.4576 110.08 16.4176 110.102 17.5483H106.198C106.176 16.951 106.027 16.471 105.75 16.1083C105.494 15.7243 105.131 15.4363 104.662 15.2443C104.192 15.0523 103.638 14.9563 102.998 14.9563C101.995 14.9563 101.227 15.1483 100.694 15.5323C100.182 15.9163 99.9256 16.4176 99.9256 17.0363C99.9256 17.527 100.064 17.9216 100.342 18.2203C100.619 18.519 101.046 18.7536 101.622 18.9243C102.198 19.0736 102.934 19.2123 103.83 19.3403C104.704 19.447 105.536 19.5963 106.326 19.7883C107.136 19.9803 107.851 20.2576 108.47 20.6203C109.088 20.983 109.568 21.4843 109.91 22.1243C110.272 22.743 110.454 23.5536 110.454 24.5563C110.454 26.3696 109.782 27.7136 108.438 28.5883C107.115 29.4416 105.302 29.8683 102.998 29.8683Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_25",
    x: -4,
    y: -4,
    width: 119.886,
    height: 46.0966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_25"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_25",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddddd_1_25",
    x: 3.41662,
    y: 6,
    width: 32.0522,
    height: 28.2344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.0862745 0 0 0 0 0.0901961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.194317
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0971584
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.0862745 0 0 0 0 0.0901961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_25",
    result: "effect2_dropShadow_1_25"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.388634
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.194317
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.0862745 0 0 0 0 0.0901961 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1_25",
    result: "effect3_dropShadow_1_25"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.971584
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.291475
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.0862745 0 0 0 0 0.0901961 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1_25",
    result: "effect4_dropShadow_1_25"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55453
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.291475
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.0862745 0 0 0 0 0.0901961 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1_25",
    result: "effect5_dropShadow_1_25"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_1_25",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.b68fd566071f62ef71f0b3037e61a5ce.svg";
export { ForwardRef as ReactComponent };